module.exports = __webpack_public_path__ + "img/landingpage-video-desktop.39d0de15.svg";